// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as RiskEducationRouteImport } from './routes/risk-education'
import { Route as RiskDisclosureRouteImport } from './routes/risk-disclosure'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PerformanceMethodologyRouteImport } from './routes/performance-methodology'
import { Route as PerformanceRouteImport } from './routes/performance'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LegendsRouteImport } from './routes/legends'
import { Route as IntegrityRouteImport } from './routes/integrity'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthenticatedUpgradeRouteImport } from './routes/_authenticated/upgrade'
import { Route as AuthenticatedSignalsRouteImport } from './routes/_authenticated/signals'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedReferralsRouteImport } from './routes/_authenticated/referrals'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedJournalRouteImport } from './routes/_authenticated/journal'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCalculatorRouteImport } from './routes/_authenticated/calculator'
import { Route as AuthenticatedBacktestRouteImport } from './routes/_authenticated/backtest'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedCheckoutReturnRouteImport } from './routes/_authenticated/checkout/return'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminTelegramRouteImport } from './routes/_authenticated/admin/telegram'
import { Route as AuthenticatedAdminSubscriptionsRouteImport } from './routes/_authenticated/admin/subscriptions'
import { Route as AuthenticatedAdminSignalsRouteImport } from './routes/_authenticated/admin/signals'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminSeoRouteImport } from './routes/_authenticated/admin/seo'
import { Route as AuthenticatedAdminSentryTestRouteImport } from './routes/_authenticated/admin/sentry-test'
import { Route as AuthenticatedAdminSecurityRouteImport } from './routes/_authenticated/admin/security'
import { Route as AuthenticatedAdminMarketRouteImport } from './routes/_authenticated/admin/market'
import { Route as AuthenticatedAdminContentRouteImport } from './routes/_authenticated/admin/content'
import { Route as AuthenticatedAdminComplianceRouteImport } from './routes/_authenticated/admin/compliance'
import { Route as AuthenticatedAdminApiKeysRouteImport } from './routes/_authenticated/admin/api-keys'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const RiskEducationRoute = RiskEducationRouteImport.update({
            id: '/risk-education',path: '/risk-education',getParentRoute: () => rootRouteImport
          })
const RiskDisclosureRoute = RiskDisclosureRouteImport.update({
            id: '/risk-disclosure',path: '/risk-disclosure',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PerformanceMethodologyRoute = PerformanceMethodologyRouteImport.update({
            id: '/performance-methodology',path: '/performance-methodology',getParentRoute: () => rootRouteImport
          })
const PerformanceRoute = PerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LegendsRoute = LegendsRouteImport.update({
            id: '/legends',path: '/legends',getParentRoute: () => rootRouteImport
          })
const IntegrityRoute = IntegrityRouteImport.update({
            id: '/integrity',path: '/integrity',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => AuthRoute
          })
const AuthenticatedUpgradeRoute = AuthenticatedUpgradeRouteImport.update({
            id: '/upgrade',path: '/upgrade',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSignalsRoute = AuthenticatedSignalsRouteImport.update({
            id: '/signals',path: '/signals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedReferralsRoute = AuthenticatedReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedJournalRoute = AuthenticatedJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCalculatorRoute = AuthenticatedCalculatorRouteImport.update({
            id: '/calculator',path: '/calculator',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBacktestRoute = AuthenticatedBacktestRouteImport.update({
            id: '/backtest',path: '/backtest',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCheckoutReturnRoute = AuthenticatedCheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTelegramRoute = AuthenticatedAdminTelegramRouteImport.update({
            id: '/telegram',path: '/telegram',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSubscriptionsRoute = AuthenticatedAdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSignalsRoute = AuthenticatedAdminSignalsRouteImport.update({
            id: '/signals',path: '/signals',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSeoRoute = AuthenticatedAdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSentryTestRoute = AuthenticatedAdminSentryTestRouteImport.update({
            id: '/sentry-test',path: '/sentry-test',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSecurityRoute = AuthenticatedAdminSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMarketRoute = AuthenticatedAdminMarketRouteImport.update({
            id: '/market',path: '/market',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminContentRoute = AuthenticatedAdminContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminComplianceRoute = AuthenticatedAdminComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminApiKeysRoute = AuthenticatedAdminApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AuthenticatedAdminRouteRoute
          })





const AuthenticatedAdminRouteRouteChildren = {
  AuthenticatedAdminApiKeysRoute: AuthenticatedAdminApiKeysRoute,AuthenticatedAdminComplianceRoute: AuthenticatedAdminComplianceRoute,AuthenticatedAdminContentRoute: AuthenticatedAdminContentRoute,AuthenticatedAdminMarketRoute: AuthenticatedAdminMarketRoute,AuthenticatedAdminSecurityRoute: AuthenticatedAdminSecurityRoute,AuthenticatedAdminSentryTestRoute: AuthenticatedAdminSentryTestRoute,AuthenticatedAdminSeoRoute: AuthenticatedAdminSeoRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminSignalsRoute: AuthenticatedAdminSignalsRoute,AuthenticatedAdminSubscriptionsRoute: AuthenticatedAdminSubscriptionsRoute,AuthenticatedAdminTelegramRoute: AuthenticatedAdminTelegramRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteRouteWithChildren = AuthenticatedAdminRouteRoute._addFileChildren(AuthenticatedAdminRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,AuthenticatedBacktestRoute: AuthenticatedBacktestRoute,AuthenticatedCalculatorRoute: AuthenticatedCalculatorRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedJournalRoute: AuthenticatedJournalRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedReferralsRoute: AuthenticatedReferralsRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedSignalsRoute: AuthenticatedSignalsRoute,AuthenticatedUpgradeRoute: AuthenticatedUpgradeRoute,AuthenticatedCheckoutReturnRoute: AuthenticatedCheckoutReturnRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRouteWithChildren,DisclaimerRoute: DisclaimerRoute,IntegrityRoute: IntegrityRoute,LegendsRoute: LegendsRoute,LoginRoute: LoginRoute,OnboardingRoute: OnboardingRoute,PerformanceRoute: PerformanceRoute,PerformanceMethodologyRoute: PerformanceMethodologyRoute,PrivacyRoute: PrivacyRoute,RiskDisclosureRoute: RiskDisclosureRoute,RiskEducationRoute: RiskEducationRoute,SignupRoute: SignupRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,GuidesSlugRoute: GuidesSlugRoute,GuidesIndexRoute: GuidesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)